import { emptyArray } from '../../../shared/misc';
import {
  getSettings, isActive, linkRemove, linkSetHref
} from './util';

const normalizePagerUrl = ({ pageUrl, isExactPath = false }) => (isExactPath ? `^${pageUrl}$` : pageUrl);
const matchPathname = (pathname) => (item) => new RegExp(normalizePagerUrl(item), 'i').test(pathname);

// Why we check for shouldRemove?
// If we come to a pageB that should not have canonical link from
// a pageA that had canonical link created, the pageB would expose
// canonical link for pageA even thought we would be on pageB.
const shouldRemove = ({ pathname }) => {
  const { excludeList = emptyArray } = getSettings();

  return excludeList.some(matchPathname(pathname));
};

export const setCanonicalLink = () => {
  // if module is not active do not take any actions
  if (!isActive()) return;

  if (shouldRemove(window.location)) {
    linkRemove();
  } else {
    linkSetHref(window.location);
  }
};
